import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
const ABOUT_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/1b0ca2c3-aea5-4a27-bd89-46874eeb4934.jpg';
export function About() {
  return <section id="nosotros" className="w-full bg-vm-bg py-28 lg:py-36" data-id="element-14" data-mp="2trr2ybuj0voy">
      <div className="max-w-7xl mx-auto px-6 lg:px-10" data-id="element-15" data-mp="2yt84m9ku4m6l">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-16" data-mp="33r9j0h7bfxbq">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.6
        }} data-id="element-17" data-mp="33p5go3p2f6dk">
            <h2 className="font-syne text-4xl font-bold leading-[1.03] text-white sm:text-5xl lg:text-[56px]" data-id="element-18" data-mp="3himy9iy6y90y">
              Más de 3 años creando contenido audiovisual de impacto
            </h2>
            <p className="mt-7 max-w-xl text-lg font-light leading-relaxed text-vm-muted" data-id="element-19" data-mp="3rgu5vb6lbeqa">
              Somos un equipo de realizadores, directores de fotografía y productores especializados en comunicación corporativa, eventos en vivo y contenido digital para marcas líderes del Uruguay.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7
        }} className="relative" data-id="element-20" data-mp="2cpr8hzv7y5z9">
            <div className="relative overflow-hidden" data-id="element-21" data-mp="30g3lhp5bmswp">
              <img src={ABOUT_IMG} alt="Director de fotografía operando una cámara de cine en un estudio de producción" className="aspect-[4/5] h-full w-full object-cover" data-id="element-22" data-mp="30gn6jeq9pxey" />
              <div className="absolute inset-0 ring-1 ring-inset ring-vm-sky/30" data-id="element-23" data-mp="2qohbtx8mt1w2" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}